<template>
  <TrackedCategoriesScreen :account-id="accountId" direction="outgoing" i18n-prefix="budget" />
</template>

<script lang="ts" setup>
import TrackedCategoriesScreen from "@/views/Account/views/TrackedCategories/TrackedCategoriesScreen.vue";

defineProps<{
  accountId: string;
}>();
</script>
